module.exports = {
    userAgent: null,
 };